module.exports = __webpack_public_path__ + "img/2.3e4aacaf.jpg";